import { render, staticRenderFns } from "./Preservation.vue?vue&type=template&id=948f90c0&scoped=true&"
import script from "./Preservation.vue?vue&type=script&lang=ts&"
export * from "./Preservation.vue?vue&type=script&lang=ts&"
import style0 from "./Preservation.vue?vue&type=style&index=0&id=948f90c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948f90c0",
  null
  
)

export default component.exports